import { render, staticRenderFns } from "./InspeccionDocumentos.vue?vue&type=template&id=0f725034"
import script from "./InspeccionDocumentos.vue?vue&type=script&lang=js"
export * from "./InspeccionDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports